module.exports = __webpack_public_path__ + "static/img/5.dd3b761.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/eng/5.png
// module id = KWRh
// module chunks = 0